import { useCallback } from "react";
import omit from "lodash/omit";

import Select from "../Select/Select";
import AsyncPaginateSelect from "../Select/AsyncPaginateSelect";
import inputConnect from "./inputConnect";
import { useFieldContext } from "../Form/Field";

const SelectInput = props => {
  const { fieldId } = useFieldContext();
  const { fieldName, options, updateValue, onChange } = props;
  const selectedValue = props.value || { value: "" };

  const handleOptionChanged = useCallback(
    option => {
      updateValue({ value: option });

      if (onChange) onChange(option);
    },
    [onChange, updateValue]
  );

  // The react-select components accepts a { value, label } option object as
  // its value prop, so we ensure that we have an option object to pass to
  // the component.
  const value =
    selectedValue.value && !selectedValue.label
      ? options.find(option => option.value === selectedValue.value)
      : selectedValue;

  const passthroughProps = omit(props, [
    "defaultValue",
    "value",
    "updateValue",
    "fieldName",
    "formKey",
    "onChange",
    "options"
  ]);

  // A select handed a way to load its options searches them instead of listing them,
  // for lists too long to be sent with the page. It takes any options it is given as
  // its first page, and would then wait for a search before loading the real one.
  const searched = Boolean(props.loadOptions);
  const SelectComponent = searched ? AsyncPaginateSelect : Select;
  const listedOptions = searched ? undefined : options;

  return (
    <SelectComponent
      inputId={fieldId}
      className="react-select"
      classNamePrefix="react-select"
      name={fieldName}
      value={value}
      options={listedOptions}
      onChange={handleOptionChanged}
      styles={{ menu: provided => ({ ...provided, zIndex: 2000 }) }}
      {...passthroughProps}
    />
  );
};

export default inputConnect(SelectInput, { fields: { value: null } });
